import TagManager from 'react-gtm-module';
import appConfig from '../appConfig';
import React from 'react';

const useGoogleTagManager = () => {
	const startRegistration = React.useCallback(() => {
		if (appConfig.googleTagManagerID) {
			TagManager.dataLayer({
				dataLayer: {
					event: 'start_registration',
				},
			});
		}
	},[]);

	const completeRegistration = React.useCallback(() => {
		if (appConfig.googleTagManagerID)
			TagManager.dataLayer({
				dataLayer: {
					event: 'complete_registration',
				},
			});
	},[]);

	return {
		startRegistration,
		completeRegistration,
	};
};

export default useGoogleTagManager;
